import React, { useMemo } from "react";
import { useSelector } from 'react-redux';

import {
  Button,
  Col,
} from '@lockerpm/design';

import global from "../../config/global";
import common from "../../utils/common";

import { CipherType } from "../../web-sh/src/core-js/src/enums";

const Actions = (props) => {
  const {
    actions = [],
  } = props

  const isMobile = useSelector((state) => state.system.isMobile);
  const currentPage = useSelector(state => state.system.currentPage);
  const plan = useSelector((state) => state.payment.plan);
  const planLimit = useSelector((state) => state.payment.planLimit);
  const tutorialRunning = useSelector((state) => state.onboarding.tutorialRunning);

  const isFreePlan = common.isFreePlan();

  const isLimited = useMemo(() => {
    const itemsTotal = planLimit?.ciphers;
    const itemsLimit = planLimit?.plan_limit;

    if (!isFreePlan || !itemsTotal || !itemsLimit) {
      return false;
    }
    if (currentPage.name == global.keys.MY_SHARED_ITEMS && currentPage.query?.menu_type !== global.constants.MENU_TYPES.QUICK_SHARES) {
      return true
    }
    if (currentPage.name == global.keys.AUTHENTICATOR) {
      return itemsTotal[CipherType.TOTP] >= (itemsLimit[CipherType.TOTP] || global.constants.FREE_PLAN_LIMIT[CipherType.TOTP])
    }
    if ([
      global.keys.PASSWORDS,
      global.keys.NOTES,
      global.keys.CARDS,
      global.keys.CRYPTO_BACKUPS,
      global.keys.IDENTITIES,
      global.keys.VAULT,
      global.keys.FOLDER_DETAIL
    ].includes(currentPage.name)) {
      return (itemsTotal.total - itemsTotal[CipherType.TOTP]) >= itemsLimit.limit_total
    }
    return false
  }, [currentPage, planLimit, plan])

  const buttonClass = (action) => {
    if (currentPage.name == global.keys.VAULT && action.key === 'add') {
      return 'add-item'
    }
    return ''
  }

  const handleClick = (action) => {
    if (isLimited && action.key === 'add') {
      common.togglePlanNoticeModal(() => action.click())
    } else {
      if (buttonClass(action) && tutorialRunning) {
        action.click(true);
      } else {
        action.click();
      }
    }
  }

  return (
    <>
      {
        actions.filter((a) => !a.hide).map((a) =>
          <Col key={a.key}>
            <Button
              className={buttonClass(a)}
              size={a.size}
              key={a.key}
              type={a.type}
              loading={a.loading}
              danger={a.danger}
              disabled={a.disabled}
              ghost={a.ghost}
              onClick={() => handleClick(a)}
              icon={a.icon}
            >
              {isMobile ? '' : a.label}
            </Button>
          </Col>
        )
      }
    </>
  );
}

export default Actions;